import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

export const useSnackbarError = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: 'error' });
    },
    [enqueueSnackbar],
  );
};
